export interface IUser {
  id?: any;
  userId?: string;
  // fullName?: string;
  email?: string;
  // activated?: boolean;
  // langKey?: string;
  // authorities?: string[];
  // createdBy?: string;
  // createdDate?: Date;
  // lastModifiedBy?: string;
  // lastModifiedDate?: Date;
  password?: string;
  role?: string;
  no?: string;
  /**
   * role id
   */
  roleId?: Number;
  nickName?: string;
  tenantId?: string;
  superUser?: string;
  sub?: string;
}

export class User implements IUser {
  constructor(
    public id?: any,
    public userId?: string,
    // public fullName?: string,
    public email?: string,
    // public activated?: boolean,
    // public langKey?: string,
    // public authorities?: string[],
    // public createdBy?: string,
    // public createdDate?: Date,
    // public lastModifiedBy?: string,
    // public lastModifiedDate?: Date,
    public password?: string,
    public role?: string,
    public no?: string,
    public roleId?: Number,
    public nickName?: string,
    public tenantId?: string,
    public superUser?: string,
    public sub?: string
  ) {}
  isSelected?: boolean;
}
